// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"06cac76541461a7dd72a","655":"6523cf91b70a5ad17d0c"}[chunkId] + ".js";
};